import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallLogDialogModule } from 'src/app/common-components/call-logs-dialog copy/call-logs-dialog.module';
import { DateFilterModule } from 'src/app/common-components/date-filter/date-filter.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AccountLogRegisterComponent } from './account-log-register/containers/account-log-register.component';
import { AccountLogRegisterViewComponent } from './account-log-register/views/account-log-register-view.component';
import { LogRegisterEffects } from './state/system-log-register.effects';
import { logRegisterReducer, systemLogRegisterFeatureKey } from './state/system-log-register.reducer';
import { SystemLogRegisterComponent } from './system-log-register/containers/system-log-register.component';
import { SystemLogRegisterViewComponent } from './system-log-register/views/system-log-register-view.component';

@NgModule({
   declarations: [
      SystemLogRegisterComponent,
      SystemLogRegisterViewComponent,
      AccountLogRegisterComponent,
      AccountLogRegisterViewComponent,
   ],
   imports: [
      CommonModule,
      AddSpacesPipeModule,
      DateFilterModule,
      EntitySelectModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      LcsDatepickerModule,
      MatButtonModule,
      MatNativeDateModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      CallLogDialogModule,
      EffectsModule.forFeature([LogRegisterEffects]),
      StoreModule.forFeature(systemLogRegisterFeatureKey, logRegisterReducer),
   ],
})
export class SystemLogRegisterModule {}
